module.exports = __webpack_public_path__ + "static/img/gyzq-bg.01d6c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyzq-bg.png
// module id = rPRp
// module chunks = 3